import { render, staticRenderFns } from "./membersPage.vue?vue&type=template&id=51ddb0e9&scoped=true"
import script from "./membersPage.vue?vue&type=script&lang=js"
export * from "./membersPage.vue?vue&type=script&lang=js"
import style0 from "./membersPage.vue?vue&type=style&index=0&id=51ddb0e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ddb0e9",
  null
  
)

export default component.exports